<template>
  <div>
    <h1>{{ $t('noMoreBountyCampaigns') }}</h1>
    <!-- <a href="#" @click.prevent="clickHandler();">
      <span>check other offers</span>
      <svg-icon icon="arrow-right" class="icon-xs" />
    </a> -->
  </div>
</template>

<script>
export default {
  methods: {
    clickHandler() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  width: 100%;
  text-align: center;
  padding: 2rem 0;
  max-width: 460px;
  margin: 0 auto;

  img {
    max-width: 167px;
    margin-bottom: 2rem;
  }

  h1 {
    margin-bottom: 1rem;
  }

  a {
    text-transform: uppercase;
    font-weight: $font-weight-bold;
    color: $primary;

    &:hover {
      color: $primary-hover;
      text-decoration: none;
    }

    &:active {
      color: $primary-active;
    }

    span,
    i {
      display: inline-block;
      vertical-align: middle;
    }

    i {
      position: relative;
      top: -1px;
    }
  }
}
</style>
